import React from 'react';
import { motion } from 'framer-motion';
const reviews = [{
  name: 'Valentina M.',
  text: 'Flavia es una verdadera artista. Logró el rubio que siempre quise y mi pelo se siente más sano que nunca.'
}, {
  name: 'Sofía R.',
  text: 'Llegué desesperada con manchas naranjas. El resultado superó mis expectativas. El ambiente es hermoso.'
}, {
  name: 'Camila T.',
  text: 'Salí renovada, el corte tiene un movimiento increíble y es súper fácil de peinar en casa. Atención 10/10.'
}];
export const Reviews = () => {
  return <section id="reviews" className="bg-[#0A0A0A] py-32 relative" data-id="element-87">
      <div className="max-w-5xl mx-auto px-6" data-id="element-88">
        <motion.h2 initial={{
        opacity: 0
      }} whileInView={{
        opacity: 1
      }} viewport={{
        once: true
      }} className="font-serif text-2xl md:text-3xl text-gold text-center tracking-[0.2em] uppercase mb-24 font-light" data-id="element-89">
          Reseñas
        </motion.h2>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-16" data-id="element-90">
          {reviews.map((review, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.2,
          duration: 0.8
        }} className="flex flex-col text-center" data-id="element-91">
              <p className="font-sans font-light text-offwhite/70 text-sm leading-relaxed mb-8 italic" data-id="element-92">
                "{review.text}"
              </p>
              <div className="w-8 h-px bg-gold/30 mx-auto mb-4" data-id="element-93"></div>
              <h4 className="font-serif text-lg text-gold uppercase tracking-widest font-light" data-id="element-94">
                {review.name}
              </h4>
            </motion.div>)}
        </div>
      </div>
    </section>;
};